import React, { useEffect } from 'react'
import { space } from '@entur/tokens'
import { Heading1 } from '@entur/typography'
import { useNavigate, useParams, useLocation } from 'react-router'
import { BreadcrumbItem, BreadcrumbNavigation } from '@entur/menu'
import { Loader } from '@entur/loader'

import { useApi } from '../api-clients/client-hooks'
import { getEmployee } from '../api-clients/eba-clients'
import { FetchState } from '../api-clients/api-types'
import { EmployeeProvider } from '../contexts/employee-context'
import { HistoryState } from '../types'
import { ChangeEmployeeForm } from '../components/employee/change-employee-form'

const ChangeEmployeePage: React.FC = () => {
  const navigate = useNavigate()
  const loc = useLocation()
  const locState = loc.state as HistoryState
  const { id } = useParams<{ id: string }>()

  const employeeFromState = locState.employee
  const [response, fetch] = useApi(getEmployee)

  useEffect(() => {
    if (!employeeFromState && response.status === FetchState.NOT_STARTED) {
      fetch({
        id,
      })
    }
  }, [employeeFromState, id, fetch, response])

  const goBack = (e?: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
    e?.preventDefault()
    navigate(-1)
  }

  const employee = response.status === FetchState.SUCCESS ? response.data : employeeFromState

  return (
    <>
      {employeeFromState && (
        <BreadcrumbNavigation>
          <BreadcrumbItem onClick={goBack}>
            {employeeFromState.firstName} {employeeFromState.surname}
          </BreadcrumbItem>
          <BreadcrumbItem>Endre persondata</BreadcrumbItem>
        </BreadcrumbNavigation>
      )}

      <Heading1 style={{ marginTop: space.extraLarge2 }}>Endre persondata</Heading1>
      {response.status === FetchState.LOADING && <Loader>Behandler</Loader>}
      {employee && (
        <EmployeeProvider initEmployee={(() => employee)()}>
          <ChangeEmployeeForm onAbort={goBack} />
        </EmployeeProvider>
      )}
      {response.status === FetchState.ERROR && Error() && <div>En feil oppstod. Vennligst prøv igjen senere.</div>}
    </>
  )
}

export default ChangeEmployeePage
